import { IP_DELETE_SUCCEEDED, IP_LIST_REQUESTED } from '../actionConstants';

import { arrayToObject, mergeObjects } from './utils';

const defaultState = {};

export default (state = defaultState, action) => {
  switch (action.type) {
    case IP_DELETE_SUCCEEDED: {
      const newState = { ...state };
      delete newState[action.id];
      return {
        ...newState,
      };
    }
    case IP_LIST_REQUESTED: {
      const newState = mergeObjects(state, arrayToObject(action.payload.data));
      return {
        ...newState,
      };
    }
    default:
      return state;
  }
};
